import { Button } from "@triumph/design-system"
import { DataTable } from "@/app/shared/components/DataTable/DataTable"
import { BillingReminderTableWrapper, ButtonsWrapper, SubmitButton } from "./PendingInvoices.StyledComponents"
import { BillingReminder } from "../billingReminder.types"
import { pendingInvoicesTableColumns } from "./PendingInvoicesTableColumns"
import { useTranslation } from "react-i18next"
import { TableTitleHeader } from "@/app/shared/components/DataTable/Components/TableTitleHeader"
import { ButtonFooter } from "../PastDueInvoicesTable/PastDueInvoices.StyledComponents"

interface PendingInvoicesTableProps {
    isSubmitDisabled: (boolean)
    totalInvoices: (number)
    rows: BillingReminder[]
    handleFormSubmit: () => void
    handleNotesChange: (invoiceNumber: string, includeDisputedReasons: boolean) => void
    handlePaymentDateChange: (invoiceNumber: string, selectedPaymentDate: string) => void
    skipOptionalInvoices: () => void
    toggleUnableToSubmitMessage: (showErrorMessage: boolean) => void
}

export const PendingInvoicesTable = ({
    isSubmitDisabled,
    totalInvoices,
    rows,
    handleFormSubmit,
    handleNotesChange,
    handlePaymentDateChange,
    skipOptionalInvoices,
    toggleUnableToSubmitMessage
}: PendingInvoicesTableProps ) => {

    const { t } = useTranslation('billingReminder');
    
    const columnFormat = pendingInvoicesTableColumns({
        handlePaymentDateChange,
        handleNotesChange
    })
    return (
        <div>
            <BillingReminderTableWrapper>
                <TableTitleHeader 
                    title={`Upcoming Invoices (${totalInvoices > 10 ? '10 of '+ totalInvoices: totalInvoices}) - OPTIONAL`}
                />
                <DataTable
                    data={rows ?? []}
                    columns={columnFormat}
                    isShowOverflow={true}
                    textWrapMode={2}
                    alternateRowColor={false}
                    maxHeight="none"
                />
            </BillingReminderTableWrapper>
            <ButtonFooter>
                <ButtonsWrapper>
                    <Button
                        onClick={() => {skipOptionalInvoices()}}
                    >
                        {t('button.skip')}
                    </Button>
                    <SubmitButton onClick={()=>toggleUnableToSubmitMessage(isSubmitDisabled)}>
                        <Button 
                            disabled={isSubmitDisabled}
                            type="submit" 
                            onClick={() => {handleFormSubmit()}}
                        >
                            {t('button.altSubmit')}
                        </Button>
                    </SubmitButton>
                </ButtonsWrapper>
            </ButtonFooter>
        </div>
    )
}